export default __webpack_public_path__ + "static/media/IconDesc_QuartzResource.256.995f6f96.png";